import {Collapse, debounce, Grid} from "@mui/material";
import {useCallback, useRef, useState} from "react";
import MhdInput from "../../atomicComponents/MhdInput";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";
import MhdMarkerSymbolChoices from "../../atomicComponents/MhdMarkerSymbolChoices";
import MhdLineWidthChoices from "../../atomicComponents/MhdLineWidthChoices";
import MhdLineStyleChoices from "../../atomicComponents/MhdLineStyleChoices";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import MhdDatetime from "../../atomicComponents/MhdDatetime";
import dayjs from "dayjs";
import {getCrToDt, getDtToCr} from "../../../utils/api";
import MhdSolidColorWidget from "../../atomicComponents/MhdSolidColorWidget";
import {setAndUpdate} from "../../../utils/helpers";
import MhdSwitch from "../../atomicComponents/MhdSwitch";
import {debounceInterval} from "../../../utils/globals";
import {useDatetimeCarringtonConverter} from "../../../hooks/useDatetimeCarringtonConverter";

const PointWidget = ({data, mods, warn, errs, update, setter, shared}) => {
  const [customizeStyle, setCustomizeStyle] = useState(false)
  const [cri, setCri] = useState(null)
  const { dtToCR, crToDT } = useDatetimeCarringtonConverter(setter, update);

  return (
    <Grid container>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label='QUERY TIME'
            value={data.query_point}
            onChange={useCallback((v) => setAndUpdate('query_point', v, setter, update), [])}
        >
          <Collapse in={data.query_point} >
            <Grid container spacing={1} pt={"2px"} pb={1}>
              <Grid item xs={7}>
                <MhdDatetime
                  label={"Time of Interest"}
                  value={data.point_xvalue}
                  override={mods.point_xvalue}
                  warning={warn.point_xvalue}
                  error={errs.point_xvalue}
                  onChange={useCallback((v) => dtToCR('point_xvalue', v, setCri), [])}
                />
              </Grid>
              <Grid item xs={5}>
                <MhdInput
                  label={"Time of Interest (CR)"}
                  value={cri}
                  onChange={useCallback((v) => crToDT('point_xvalue', v, setCri), [])}
                  units={"CR"}
                  clear={true}
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>

      <Grid item xs={12}>
        <Collapse in={data.query_point}>
          <MhdWidgetDivider
            pt={4}
            label='CUSTOMIZE STYLE'
            value={customizeStyle}
            onChange={setCustomizeStyle}
          >
            <Collapse in={customizeStyle}>
              <Grid container spacing={1} pt={'2px'}>
                <Grid item xs={3}>
                  <MhdSolidColorWidget
                    label='Line Color'
                    value={data.color}
                    onChange={useCallback((v) => setAndUpdate('color', v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={3}>
                  <MhdMarkerSymbolChoices
                    label='Symbols'
                    value={data.marker_symbol}
                    onChange={useCallback((v) => setAndUpdate('marker_symbol', v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={3}>
                  <MhdLineWidthChoices
                    label='Line Width'
                    value={data.line_width}
                    onChange={useCallback((v) => setAndUpdate('line_width', v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={3}>
                  <MhdLineStyleChoices
                    label='Line Style'
                    value={data.line_style}
                    onChange={useCallback((v) => setAndUpdate('line_style', v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={4}>
                  <MhdSwitch
                    label='Show Point'
                    value={data.show_point}
                    onChange={useCallback((v) => setAndUpdate('show_point', v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={4}>
                  <MhdSwitch
                    label='Show Lines'
                    value={data.show_lines}
                    onChange={useCallback((v) => setAndUpdate('show_lines', v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={4}>
                  <MhdSwitch
                    label='Show Text'
                    value={data.show_text}
                    onChange={useCallback((v) => setAndUpdate('show_text', v, setter, update), [])}
                  />
                </Grid>
              </Grid>
            </Collapse>
          </MhdWidgetDivider>
        </Collapse>
      </Grid>
    </Grid>
  );
}

export default PointWidget;